import React from 'react'

import moment from 'moment'

import { getMessage } from '../../util/IntlMessages'
import { FunctionalityCard, PhoneInput, RealCaseCard } from './components'
import PortalLogo from '../../assets/images/farmer-portal-logo.svg'
import FarmerLogo from '../../assets/images/farmer-logo-2.svg'
import ArrowBottom from '../../assets/images/arrow-bottom.svg'
import FarmerImage1 from '../../assets/images/farmer-image-1.svg'
import FarmerImage2 from '../../assets/images/farmer-image-2.svg'
import { request } from '../../util/handlerRequestUtil'
import * as api from '../../services/api'
import './Styles.css'

const functionalities = [
  {
    image: require('../../assets/images/functionality-1.svg'),
    title: getMessage('landing-page.functionality-1.title'),
    description: getMessage('landing-page.functionality-1.description')
  },
  {
    image: require('../../assets/images/functionality-2.svg'),
    title: getMessage('landing-page.functionality-2.title'),
    description: getMessage('landing-page.functionality-2.description')
  },
  {
    image: require('../../assets/images/functionality-3.svg'),
    title: getMessage('landing-page.functionality-3.title'),
    description: getMessage('landing-page.functionality-3.description')
  }
]

const cases = [
  {
    image: require('../../assets/images/farmer-1.png'),
    name: 'Rodrigo Fernandes',
    testimonial: getMessage('landing-page.cases.case-1')
  },
  {
    image: require('../../assets/images/farmer-2.png'),
    name: 'Marília Freitas',
    testimonial: getMessage('landing-page.cases.case-2')
  },
  {
    image: require('../../assets/images/farmer-3.png'),
    name: 'Manuel Coelho',
    testimonial: getMessage('landing-page.cases.case-3')
  },
  {
    image: require('../../assets/images/farmer-4.png'),
    name: 'Álvaro Teixeira',
    testimonial: getMessage('landing-page.cases.case-4')
  }
]

const LandingPage = () => {
  async function handlePhoneSubmit(value) {
    const params = {
      phone: value
    }
    const response = await request(api.sendPin(params))
    if (response.status === 200) {
      const appStorage = window.localStorage
      appStorage.setItem('phone', params.phone)
      window.location.href = `/farmers/validation`
    }
  }

  return (
    <div className="farmers-portal">
      <div className="presentation">
        <img className="portal-logo" src={FarmerLogo} alt="farmers-logo" />
        <div className="abs-img presentation-bg hide-mobile" />
        <div className="know-more">
          <a href="#how-it-works">
            <p>{getMessage('landing-page.presentation.know-more')}</p>
            <img src={ArrowBottom} alt="arrow-bottom" />
          </a>
        </div>

        <div className="wrapper">
          <div className="image-bg">
            <img src={FarmerImage1} alt="farmer-images-1" />
          </div>
          <div className="abs-img presentation-bg hide-desktop" />
          <div className="abs-img farmer-cloud-img-1" />
          <div className="abs-img farmer-cloud-img-2" />

          <div className="border-effect">
            <div className="content">
              <p className="title">
                <strong>{getMessage('landing-page.presentation.title-1')}</strong>{' '}
                {getMessage('landing-page.presentation.title-2')}{' '}
                <strong>{getMessage('landing-page.presentation.title-3')}</strong>{' '}
                {getMessage('landing-page.presentation.title-4')}{' '}
                <strong>{getMessage('landing-page.presentation.title-5')}</strong>
              </p>
              <PhoneInput handleSubmit={handlePhoneSubmit} />
            </div>
          </div>
        </div>
      </div>

      <div id="how-it-works" className="how-it-works">
        <p className="title">{getMessage('landing-page.how-it-works.title')}</p>
        <div className="wrapper">
          {functionalities.map((obj) => (
            <FunctionalityCard key={obj.title} {...obj} />
          ))}
        </div>
      </div>

      <div className="put-your-phone">
        <div className="wrapper">
          <div className="content">
            <p className="title">{getMessage('landing-page.put-your-phone.title')}</p>
            <PhoneInput handleSubmit={handlePhoneSubmit} />
          </div>

          <div className="farmer-image">
            <img src={FarmerImage2} alt="farmer-images-2" />
          </div>
        </div>
        <div className="mountain-bg" />
      </div>

      <div className="cases">
        <p className="title">{getMessage('landing-page.cases.title')}</p>

        <div className="wrapper">
          {cases.map((obj) => (
            <RealCaseCard {...obj} key={obj.name} />
          ))}
        </div>
      </div>

      <div className="footer">
        <img className="portal-logo" src={PortalLogo} alt="farmers-logo" />
        <p>
          {moment().year()} {getMessage('landing-page.footer.title')}
        </p>
      </div>
    </div>
  )
}

export default LandingPage
